import { useCallback } from 'react';
import { useSkinStore } from '@/shared/stores/useSkinStore';
import type { SkinComponentType } from '@/shared/stores/useSkinStore';
import { SKIN_METADATA } from '@/features/game/components/board/skins/metadata';
import type { SkinId } from '@/features/game/components/board/skins/types';

const AVAILABLE_SKINS = SKIN_METADATA.filter((s) => s.available);

export function useSkinPicker() {
  const pawnSkinId = useSkinStore((s) => s.pawnSkinId);
  const diceSkinId = useSkinStore((s) => s.diceSkinId);
  const baseSkinId = useSkinStore((s) => s.baseSkinId);
  const plateauxSkinId = useSkinStore((s) => s.plateauxSkinId);
  const setComponentSkin = useSkinStore((s) => s.setComponentSkin);
  const startTrialStore = useSkinStore((s) => s.startTrial);

  const startTrial = useCallback(
    (componentType: SkinComponentType, skinId: SkinId) => {
      startTrialStore(skinId);
      setComponentSkin(componentType, skinId);
    },
    [startTrialStore, setComponentSkin]
  );

  return {
    selections: {
      pawn: pawnSkinId,
      dice: diceSkinId,
      base: baseSkinId,
      plateaux: plateauxSkinId
    },
    setComponentSkin,
    startTrial,
    availableSkins: AVAILABLE_SKINS
  };
}
